document.addEventListener("DOMContentLoaded", function() {
  // Get the countdown container and the element where the timer is displayed.
  const countdownContainer = document.getElementById('countdown-timer');
  const countdownElement = document.getElementById('countdown');

  // Set the target future date.
  // (For testing, you might want to set this to a past date to see the container hide.)
  const futureDate = new Date('31 JANUARY 2026 23:59:59').getTime();

  // Function to update the countdown timer.
  function updateCountdown() {
    const now = new Date().getTime(); // Current time in milliseconds.
    const timeleft = futureDate - now;

    // If the target date has passed, hide the container and stop updating.
    if (timeleft < 0) {
      if (countdownContainer) {
        countdownContainer.style.display = 'none';
      }
      clearInterval(countdownInterval);
      return;
    }

    // Otherwise, ensure the container is visible.
    if (countdownContainer) {
      countdownContainer.style.display = 'block';
    }

    // Calculate the remaining time components.
    const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

    // Update the countdown element's text.
    if (countdownElement) {
      countdownElement.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`;
    }
  }

  // Start the countdown interval.
  const countdownInterval = setInterval(updateCountdown, 1000);

  // Initial call to set up the countdown immediately.
  updateCountdown();
});
